// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CustomReactQuill_wrapper__3Br8_","errorText":"CustomReactQuill_errorText__3OSIl","error":"CustomReactQuill_error__3gaQZ","quill":"CustomReactQuill_quill__3ND1Y"};